var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "setting-item" },
    [
      _c(
        "el-form-item",
        { attrs: { label: "文字大小(字号)" } },
        [
          _c("el-input-number", {
            staticClass: "setting-render_indent",
            attrs: {
              "controls-position": "right",
              placeholder: "请输入文字大小",
              min: 12,
              max: 100
            },
            model: {
              value: _vm.fontSize,
              callback: function($$v) {
                _vm.fontSize = _vm._n($$v)
              },
              expression: "fontSize"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b8aa47a2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b8aa47a2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Setting/render_setting/RenderFontSize.vue
// module id = null
// module chunks = 